import {useTermsAndConditions} from "../hooks/useTermsAndConditions";

const TermsAndConditions = ({formTypeId}) => {
    const {data, isLoading, isError, isSuccess} = useTermsAndConditions({formTypeId})
    const termsLink = (isSuccess && data.length) ? `${process.env.REACT_APP_BASE_URL}/terms/${data[0]}` : '#';

    return (
        (data && data.length) ? <div className={'py-4'}>
            <span className={'block uppercase font-bold underline underline-offset-2 text-[#0A0D36]'}> Terms and Conditions</span>
            <span className={'block py-1'}> By filling out a request with this form, you agree to be bound by, and to comply with these
                <a target={'_blank'} href={termsLink}
                   className={'text-blue-700 hover:underline'}> terms and conditions </a>
            </span>
        </div> : <></>
    );
};

export default TermsAndConditions;